export default "__VITE_ASSET__02e3576c__"